export interface MenuRouteChild {
  name: string;
  matchUrl: string[];
  manager?: boolean;
}

export interface MenuRoute {
  name: string;
  matchUrl: string[];
  children: MenuRouteChild[];
  manager?: boolean;
}

const menuRouteDefinition: MenuRoute[] = [{
  name: 'Menu.translationJobs',
  matchUrl: ['translation-jobs'],
  children: [{
    name: 'Menu.dashboard',
    matchUrl: ['dashboard']
  }, {
    name: 'Menu.quotes',
    matchUrl: ['quotes', 'pending']
  }, {
    name: 'Menu.runningProjects',
    matchUrl: ['projects', 'in-progress']
  }, {
    name: 'Menu.finishedProjects',
    matchUrl: ['projects', 'finished']
  }, {
    name: 'Menu.cancelled',
    matchUrl: ['quotes', 'cancelled']
  }]
}, {
  name: 'Menu.people',
  matchUrl: ['people'],
  children: [{
    name: 'Menu.contact',
    matchUrl: ['contact']
  }, {
    name: 'Menu.team',
    matchUrl: ['team'],
    manager: true
  }, {
    name: 'Menu.profile',
    matchUrl: ['profile']
  }]
}];

const menuRoutes: MenuRoute[] = menuRouteDefinition.map(parent => ({
  ...parent,
  children: parent.children.map(child => ({
    ...child,
    matchUrl: [...parent.matchUrl, ...child.matchUrl]
  }))
}));

export { menuRoutes };
